var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleForms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_google_forms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.3636,0) scale(0.363636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 41.999971,21.999985 12.06499,2.279998 9.934995,-2.279998 L 41.999971,0 38.964972,10.429993 Z",
    style: {
      fill: "#56368a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.999971,21.999985 V 0 H 5.9999959 C 2.6849982,0 0,2.6849982 0,5.9999959 V 81.999944 c 0,3.314998 2.6849982,5.999996 5.9999959,5.999996 H 57.99996 c 3.314998,0 5.999996,-2.684998 5.999996,-5.999996 V 21.999985 Z",
    style: {
      fill: "#7248b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.999988,63.499958 c -1.654999,0 -2.999997,-1.345 -2.999997,-2.999999 0,-1.655 1.344998,-2.999997 2.999997,-2.999997 1.654998,0 2.999998,1.344997 2.999998,2.999997 0,1.654999 -1.345,2.999999 -2.999998,2.999999 z m 0,-11.999993 c -1.654999,0 -2.999997,-1.344999 -2.999997,-2.999998 0,-1.654999 1.344998,-2.999997 2.999997,-2.999997 1.654998,0 2.999998,1.344998 2.999998,2.999997 0,1.654999 -1.345,2.999998 -2.999998,2.999998 z m 0,-11.999991 c -1.654999,0 -2.999997,-1.345 -2.999997,-2.999998 0,-1.654999 1.344998,-2.999998 2.999997,-2.999998 1.654998,0 2.999998,1.344999 2.999998,2.999998 0,1.654998 -1.345,2.999998 -2.999998,2.999998 z M 49.999965,62.999957 H 24.999982 V 57.99996 h 24.999983 z m 0,-11.999992 H 24.999982 v -4.999997 h 24.999983 z m 0,-11.999992 H 24.999982 v -4.999996 h 24.999983 z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleForms);
export default __webpack_public_path__ + "static/media/google-forms.fc8358df51436ea53129fb22f019fa5b.svg";
export { ForwardRef as ReactComponent };